import { KIPolicies } from './track-metadata';

export enum Validity {
  VALID,
  INVALID,
  PENDING,
}

export type Genre = { id: string; name: string };
export type BisacGenre = { value: string; label: string; disabled?: boolean; children?: BisacGenre[] };

export enum CoverType {
  FRONT = 'FRONT_COVER',
  BACK = 'BACK_COVER',
  PROMO = 'PROMOTION',
  BOOKLET = 'BOOKLET',
  SCREENSHOT = 'SCREENSHOT',
  OTHER = 'OTHER',
}

export function isCoverType(value: unknown): value is CoverType {
  return Object.values<unknown>(CoverType).includes(value);
}

export function getCoverLabel(coverType: CoverType) {
  switch (coverType) {
    case CoverType.FRONT:
      return $localize`:@@product-wizard.data.cover-type-front:Front-Cover`;
    case CoverType.BACK:
      return $localize`:@@product-wizard.data.cover-type-back:Back-Cover`;
    case CoverType.PROMO:
      return $localize`:@@product-wizard.data.cover-type-promo:Promotion`;
    case CoverType.BOOKLET:
      return $localize`:@@product-wizard.data.cover-type-booklet:Booklet`;
    case CoverType.SCREENSHOT:
      return $localize`:@@product-wizard.data.cover-type-screenshot:Screenshot`;
    case CoverType.OTHER:
      return $localize`:@@product-wizard.data.cover-type-other:Other`;
  }
}

export type CoverImage = {
  file: File | undefined;
  type: CoverType;
  id: string;
  uploadInfo: UploadInfo;
  aiUsage?: KIPolicies;
};

export type UploadInfo =
  | { uploadType: 'single'; status: 'running' }
  | { uploadType: 'single'; status: 'done'; objectUri: string }
  | {
      uploadType: 'multi';
      status: 'running';
      finishedParts: { partNumber: number; etag?: string }[];
      uploadId: string | undefined;
      objectUri: string | undefined;
    }
  | {
      uploadType: 'multi';
      status: 'waiting';
      finishedParts: { partNumber: number; etag?: string }[];
      uploadId: string;
      objectUri: string;
    }
  | { uploadType: 'multi'; status: 'done'; objectUri: string };

export const pricecodeOptions = [
  { value: 'MB', label: 'Single (1,49€)' },
  { value: 'AS', label: 'EP (2,99€)' },
  { value: 'AD', label: 'Back (5,99€)' },
  { value: 'AB', label: 'Mid (7,99€)' },
  { value: 'AA', label: 'Front (9,99€)' },
];

export const itunesIdForPricecode: Record<string, number | undefined> = {
  MB: 14,
  AS: 5,
  AD: 32,
  AB: 33,
  AA: 34,
};
